import type { Router } from 'vue-router';

import { createGtm } from '@gtm-support/vue-gtm';

export const initGtm = (router: Router) => createGtm({
  enabled: import.meta.env.VITE_GTM_ENABLED === 'true',
  id: import.meta.env.VITE_GTM,
  vueRouter: router,
});
